<template>
  <v-card v-if="properties != null" flat class="introduction-card">
    <div class="centered">
      <span
        class="introduction-title display-2"
        v-if="properties.title != null"
      >
        {{ properties.title }}
      </span>
    </div>
    <div class="mt-4">
      <v-row align="center" justify="center">
        <v-col
          cols="12"
          md="6"
          v-for="(elem, id) in properties.buttons"
          :key="id"
          class="centered"
        >
          <Button
            class="ma-3 pa-6 introduction-buttons"
            :color="buttonColor(id)"
            :title="elem.title"
            :to="elem.to"
            :icon="elem.icon"
          ></Button>
        </v-col>
      </v-row>
    </div>
    <div v-if="properties.image != null" class="introduction-image">
      <CImage :url="properties.image" :square="false" :alt="properties.title" />
    </div>
  </v-card>
</template>

<script>
import Button from "@/components/HomeSections/SubComponents/Button";
import CImage from "@/components/HomeSections/SubComponents/Image";

export default {
  name: "Introduction",
  components: {
    Button,
    CImage
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    properties: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    buttonColor(id) {
      return id % 2 == 0 ? "primary" : "secondary";
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 960px) {
  .introduction-title {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 600;
    font-size: 42px !important;
  }
}

@media screen and (min-width: 960px) {
  .introduction-title {
    color: --var(grey_10);
    width: 70%;
    text-align: center;
    font-style: normal;
    font-weight: 600;
    font-size: 56px !important;
    line-height: 64px;
  }
}

.introduction-card {
  padding-top: 50px;
}

.introduction-buttons {
  padding-top: 30px;
  width: 100%;
  max-width: 484px;
  text-transform: none;
}

.introduction-image {
  width: 66%;
  margin-left: auto;
  margin-right: auto;
}
</style>
